module.exports = __webpack_public_path__ + "img/cn.1a48da62.png";